import React from "react";
import { AlertCircle } from "lucide-react";

/**
 * Form-level failure on the auth screens (bad credentials, server rejection).
 *
 * The shared `.vb-callout` primitive in its danger tone — not a second banner.
 * `.auth-alert` adds only what this surface needs on top: `pre-line`, because
 * the server can return several validation messages joined by newlines
 * (see `createUser` / `resetPasswordConfirm` in authService).
 */
export default function AuthAlert({ children }: { children: React.ReactNode }) {
    return (
        <div className="vb-callout vb-callout--danger auth-alert" role="alert">
            <span className="vb-callout__icon">
                <AlertCircle size={16} aria-hidden="true" />
            </span>
            <span className="vb-callout__body">{children}</span>
        </div>
    );
}
